import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Constants } from '../../../../../app.constant';

@Component({
  selector: 'ba-menu-item',
  templateUrl: './baMenuItem.html',
  styleUrls: ['./baMenuItem.scss']
})
export class BaMenuItem {

  @Input() menuItem: any;
  @Input() child: boolean = false;

  public customerInfo = Constants.CurrentCustomerInfomations();
  public enableDesktopRegistration = Constants.CurrentEnvironmentProperties("enableDesktopRegistration");

  @Output() itemHover = new EventEmitter<any>();
  @Output() toggleSubMenu = new EventEmitter<any>();

  public onHoverItem($event): void {
    this.itemHover.emit($event);
  }

  public onToggleSubMenu($event, item): boolean {
    $event.item = item;
    this.toggleSubMenu.emit($event);
    return false;
  }
  ngOnInit() {
    if (Constants.CurrentCustomerInfomations()) {
      if (Constants.CurrentCustomerInfomations().isSchedulerEnabled !== true) {
        if (this.menuItem.route.path === "cms") {
          this.menuItem.children = this.menuItem.children.filter((item: any) => {
            return item.title !== "Scheduler"
          })
        }
        if (this.menuItem.route.path === "reports") {
          this.menuItem.children = this.menuItem.children.filter((item: any) => {
            return item.title !== "Scheduler Report"
          })
        }
        if (this.menuItem.route.path === "reports") {
          this.menuItem.children = this.menuItem.children.filter((item: any) => {
            return item.title !== "Scheduler Summary Report"
          })
        }
      }
      else {
        if (this.menuItem.route.path === "cms") {
          this.menuItem.children = this.menuItem.children.filter((item: any) => {
            return item.title !== "Planogram"
          })
        }
        // if (this.menuItem.route.path === "reports") {
        //   this.menuItem.children = this.menuItem.children.filter((item: any) => {
        //     return item.title !== "Content Playback" && item.title !== "Statistics Report"
        //   })
        // }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.component.ts